var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-scrollbar',{ref:"scrollbar"},_vm._l((_vm.items),function(item,idx){return _c('div',{key:idx,staticClass:"virtual-scroller-item"},[( idx < _vm.showMaxIdx)?_vm._t("default",null,{"item":item}):_vm._e()],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }